export function NOOP() {}

export const EMPTY_ARRAY: readonly any[] = Object.freeze([]);

export const EMPTY_OBJECT = Object.freeze({});
